export default {
  请先选择一个部门: "Please select a department first",
  选择部门: "Select Department",
  请输入部门名称: "Enter department name",
};
